import { Component, OnInit } from '@angular/core';
import { GlobalErrorsHandler } from './core/errors/global-errors.handler';
import { AppContextService, RouteService } from './core/services';
import { AuthService } from './services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  title = "RentWise";

  constructor(
    public context: AppContextService,
    private auth: AuthService,
    private routeService: RouteService,
    private errorsHandler: GlobalErrorsHandler
  ) { }

  ngOnInit() {
    this.context.init();
    this.initDebugTools();

    this.auth.restoreData();
    this.auth.getAdminRole();
    this.auth.getAgencyData();

    this.routeService.primaryRoute$.subscribe(() => {
      this.errorsHandler.ignore = false; // reset on navigation
    });

    console.log("core initialized");
  }

  private initDebugTools(): void {
    if (environment.debug) {
      const win = window as any;

      win["$q"] = document.querySelector.bind(document);
      win["$qs"] = document.querySelectorAll.bind(document);

      if (win["ng"]) {
        const ng = win["ng"] as any;
        const element = (target: HTMLElement | string) => (typeof target === "string" ? document.querySelector(target) : target);
        win["$ctx"] = (target: HTMLElement | string) => ng.getContext(element(target));
        win["$c"] = (target: HTMLElement | string) => ng.getComponent(element(target));
        setTimeout(() => {
          win["$root"] = win["$c"]("app-root");
        }, 1);
      }
    }
  }
}
